import React from "react";
import {NavLink, withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import Tooltip from "../../../../components-new/general/Tooltip";
import Translate from "../../../../components/Translate";
import config from "../../../../config";

/*
 * One row of the sidebar.
 *
 * Two kinds of row share it. Most carry an icon component, which takes its
 * colour from the row and so needs nothing said about it here. The rows for
 * individual bots carry that bot's own picture instead - those are not in the
 * design, which only draws the fixed part of the menu, so they are given the
 * shape the design uses everywhere else: the same 20px slot, rounded, with the
 * picture cropped into it.
 */
const MenuItem = withRouter((props) => {
    const handleNavigate = (path) => (e) => {
        e.preventDefault();
        props.history.push(path);
        props.onNavigate();
    };

    const isActive = window.location.pathname === config.APP_BASE_PATH + props.path;
    const Icon = props.icon;
    const needTranslate = props.alt !== 'client-chat';

    const menuItem = (
        <li className={`sidebar-item ${isActive ? 'is-active' : ''}`} key={props.id}>
            <NavLink
                id={props.id}
                to={props.path}
                onClick={handleNavigate(props.path)}
                className="sidebar-link"
            >
                {/*
                    The slot holds whichever of the two a row has. Rendering
                    <Icon/> unconditionally is what broke the panel for an
                    operator: the rows for individual bots carry a picture and no
                    icon at all, so Icon was undefined and the whole page failed
                    to render. A bot with neither gets an empty slot rather than
                    a crash.
                */}
                <span className="sidebar-icon">
                    {props.imgSrc
                        ? <img className="sidebar-avatar" src={props.imgSrc} alt=""/>
                        : (Icon ? <Icon/> : null)}
                </span>

                <span className="sidebar-label">
                    {needTranslate ? <Translate text={props.name}/> : props.name}
                </span>

                {/*
                    A mark, not a count. What an operator does next is the same
                    whether there are two unread chats or forty - they open the
                    list - and the number of them is on the screen the mark leads
                    to anyway.
                */}
                {props.unread > 0 && (
                    <span className="sidebar-badge">!</span>
                )}
            </NavLink>
        </li>
    );

    /*
     * The tooltip wrapper is always here and is switched off instead of being
     * taken away.
     *
     * Rendering it only while the rail is collapsed meant the row was a
     * different tree in each state, so React threw the old <li> away and built a
     * new one on every collapse. A brand-new element has no previous value to
     * animate from, which is why the labels used to vanish on the spot rather
     * than fade: there was no transition, only a replacement.
     */
    return (
        <Tooltip
            inRightSide={true}
            text={props.name}
            needTranslate={needTranslate}
            disabled={!props.showTooltip}
        >
            {menuItem}
        </Tooltip>
    );
});

MenuItem.propTypes = {
    id: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    alt: PropTypes.string,
    imgSrc: PropTypes.string,
    icon: PropTypes.func,
    unread: PropTypes.number,
    user: PropTypes.object.isRequired,
    onNavigate: PropTypes.func,
    showTooltip: PropTypes.bool,
};

MenuItem.defaultProps = {
    unread: 0,
    onNavigate: () => {
    },
    showTooltip: false,
};

export default MenuItem;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/side-bar/MenuItem.jsx